import { Draggable, Heading, View } from '@acin/ui-core';
import styled from 'styled-components';

export const RegTextDetail = styled(Draggable)`
  z-index: 100;
  position: absolute;
  width: calc(25% - ${(p) => p.theme.spacing.getSize(3)});
  height: 80%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: grab;
  background: ${(p) => p.theme.colors.backgrounds.getValue(1)};
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  border-radius: ${(p) => p.theme.spacing.getSize()};
`;

export const TopHeading = styled(Heading)`
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  padding: ${(p) => p.theme.spacing.getSize(3)} ${(p) => p.theme.spacing.getSize(6)};
`;

export const Content = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;
